import { RegistrationDocType } from '@exam-center/graphql';
import { isThaiTitle, THAI_TITLE_OPTIONS, type ThaiTitle } from '@shared/utils';

import { DOCUMENT_TYPE_TEXT, type DocumentType, DocumentTypes } from '../../constants';

export function getNameTitleOptions() {
  return THAI_TITLE_OPTIONS;
}

export function getDocumentTypeOptions() {
  return DocumentTypes.map((type) => ({
    label: DOCUMENT_TYPE_TEXT[type],
    value: type,
  }));
}

export function convertToRegistrationType(documentType: DocumentType) {
  switch (documentType) {
    case 'CITIZEN_CARD':
      return RegistrationDocType.CitizenCard;
    case 'DRIVER_LICENSE':
      return RegistrationDocType.DriverLicense;
    case 'PASSPORT':
      return RegistrationDocType.Passport;
    case 'DIGITAL_DOCUMENT':
      return RegistrationDocType.DigitalDocument;
  }
}

export function convertStringToNameTitle(nameTitle: string): ThaiTitle | null {
  return isThaiTitle(nameTitle) ? nameTitle : null;
}
